export const DEFAULT_HERO_IMAGE = '/static/content/products/header-banner.png';
